"use client"
import React, { useCallback, useEffect, useRef, useState } from "react"
import styles from "@css/modules/Resort.module.scss"
import "@css/modules/ResortSections.module.scss"
import { ResortTop } from "../ResortTop/ResortTop"
import { ResortApartments } from "../ResortApartments/ResortApartments"
import { ResortReview } from "../ResortReview/ResortReview"
import { ResortCarousel } from "../ResortCarousel"
import { FeatureActivities } from "../FeatureActivities"
import { Partners } from "../Partners"
import { Restaurants } from "../Restaurants"
import { Offer } from "../Offer"
import { Subscribe } from "../../HomePage/Subscribe"
import { ResortFinancials } from "../ResortFinancials"
import { Resort } from "@t/Resort"

export function ResortSections({ resort, level = 1 }) {
    const [selectedResort, setSelectedResort] = useState<Resort>(resort)
    const [isLoading, setIsLoading] = useState(false)
    const intervalRef = useRef<ReturnType<typeof setTimeout>>(null)
    const rootRef = useRef<HTMLDivElement>(null)
    const onChange = useCallback((resort: Resort) => {
        rootRef.current?.style.setProperty("height", rootRef.current.offsetHeight + "px")
        setIsLoading(true)
        setSelectedResort(resort)
        clearTimeout(intervalRef.current)
        intervalRef.current = setTimeout(() => {
            setIsLoading(false)
            rootRef.current.style.height = null
        }, 100)
    }, [])
    useEffect(() => {
        return () => {
            clearTimeout(intervalRef.current)
        }
    }, [])
    const restaurant = selectedResort.restaurant || resort.restaurant
    const background = selectedResort.background?.length ? selectedResort.background : resort.background
    const reviews = selectedResort?.reviews?.length ? selectedResort?.reviews : resort.reviews
    const featuredActivities = selectedResort?.featuredActivities || resort.featuredActivities
    return (
        <div ref={rootRef}>
            <ResortTop resort={resort} level={level} />
            <Partners onChange={onChange} resort={resort} selectedId={selectedResort.id} />
            {!isLoading && (
                <>
                    <ResortApartments resort={selectedResort} />
                    <div className={styles.reviewWrapper}>
                        <ResortReview reviews={reviews} />
                        {featuredActivities && <FeatureActivities {...featuredActivities} />}
                    </div>
                    {!!background?.length && <ResortCarousel items={background} />}
                    {restaurant && <Restaurants {...restaurant} />}
                </>
            )}
            {level !== 2 && <Offer resort={resort} />}
            <ResortFinancials resort={resort} />
            <Subscribe />
        </div>
    )
}

export default ResortSections
